import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import React from 'react'
import { useTranslation } from 'react-i18next'
import InboxIcon from '@mui/icons-material/Inbox'

const NoFilterResultsPlaylist: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 8,
        gap: 2,
      }}
    >
      <InboxIcon sx={{ fontSize: 80, color: 'text.secondary' }} />
      <Typography variant="subtitle1" component="p">
        {t('NoFilterResultsPlaylist.Message', 'No playlists match your filter')}
      </Typography>
    </Box>
  )
}

export default NoFilterResultsPlaylist
